import { render, staticRenderFns } from "./UserDefine.vue?vue&type=template&id=13580d94&scoped=true&"
import script from "./UserDefine.vue?vue&type=script&lang=js&"
export * from "./UserDefine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13580d94",
  null
  
)

export default component.exports